import { Flex, Typography } from "antd";
import { formatCurrency } from "../../../../../../Utils/utils";
import { formatCount } from "../../../../components/Table/columns";
import Icon from "../../../../../../Icon";
import cls from "classnames";

const { Text } = Typography;

const getIsValidNumber = (value) => typeof value === "number" && !isNaN(value);

export const getColumns = ({ t, expandedKeys, isMobile, selectedMetric }) => {
  const allColumns = [
    {
      key: "billing_descriptor",
      title: t("Billing descriptor"),
      dataIndex: "billing_descriptor",
      render: (_, record) => {
        const row_type = record?.row_type;
        const isExpandable = record?.months?.length > 0 && row_type !== "month";
        const isExpanded = expandedKeys.includes(record?.unique_id);

        if (row_type === "month") {
          return (
            <Text style={{ paddingLeft: "28px" }} strong>
              {record?.month_name}
            </Text>
          );
        }
        return (
          <Flex gap={8} align="center">
            {isExpandable && (
              <Icon
                type="chevron_down_small"
                className={cls("chevron_down", { expanded: isExpanded })}
              />
            )}
            <Text strong>{_ ?? "—"}</Text>
          </Flex>
        );
      },
    },
    {
      key: "fraud_count",
      title: "Fraud count",
      dataIndex: "fraud_count",
      align: "right",
      render: (_, record) => {
        return <Text strong>{getIsValidNumber(_) ? formatCount(_) : "—"}</Text>;
      },
    },
    {
      key: "dispute_count",
      title: "Dispute count",
      dataIndex: "dispute_count",
      align: "right",
      render: (_, record) => {
        return <Text strong>{getIsValidNumber(_) ? formatCount(_) : "—"}</Text>;
      },
    },
    {
      key: "transaction_count",
      title: "Transaction count",
      dataIndex: "transaction_count",
      align: "right",
      render: (_, record) => {
        return <Text strong>{getIsValidNumber(_) ? formatCount(_) : "—"}</Text>;
      },
    },
    {
      key: "transaction_volume",
      title: "Transaction volume",
      dataIndex: "transaction_volume",
      align: "right",
      render: (_, record) => {
        return (
          <Text strong>
            {getIsValidNumber(_) ? formatCurrency(_, true) : "—"}
          </Text>
        );
      },
    },
  ];

  if (isMobile) {
    return allColumns.filter(
      (col) => col.key === "billing_descriptor" || col.key === selectedMetric,
    );
  }

  return allColumns;
};
